import React, { Component, useCallback, useEffect, useMemo, useState } from 'react';
import * as d3 from "d3";
import { color } from 'd3';

function Rect(props) {
    const node = props.node;
    const status = props.status;
    const longname = props.longname;
    const code = props.code;
    const distance = props.distance;
    const cases = props.cases;
    const core = props.core;
    const color = props.color;
    const format = props.format;
    const originalRects = props.originalRects;
    let selected = props.selected;
    let setSelected = props.setSelected;
    let extraNodes = props.extraNodes;
    let setExtraNodes = props.setExtraNodes;
    let selectedNodes = props.selectedNodes;
    let setSelectedNodes = props.setSelectedNodes;
    let selectedRects = props.selectedRects;
    let setSelectedRects = props.setSelectedRects;
    let unSelectedRects = props.unSelectedRects;
    let setUnSelectedRects = props.setUnSelectedRects;
    const [collapsed, setCollapsed] = useState(false);
    let [padding, setPadding] = useState('5px 8px 5px 8px');
    let added = false;
    let search = props.search;

    function selectNode(selected, code, cases) {
        if (selected) {
            selectedNodes = selectedNodes.filter(e => e.name !== code);
            selectedRects = selectedRects.filter(e => e.code !== code); 
            unSelectedRects = originalRects.filter(e => !selectedRects.includes(e)); 
            setSelected(false);
        } else {
            selectedNodes = [...selectedNodes, {name: code, cases: cases, core: core}]; 
            unSelectedRects = unSelectedRects.filter(e => e.code !== code); 
            selectedRects.push(node); 
            setSelected(true);
        }
        setSelectedNodes(selectedNodes);
        setSelectedRects(selectedRects);
        setUnSelectedRects(unSelectedRects);
    }

    function highlightNode(mode, selected) {
        if (!selected) {
            if (mode === 'enter') {
                d3.select('#w_row_' + code).style('background-color', color.lightpurple);
                d3.select('#w_button_' + code).style('color', color.pink);
            }
            else if (mode === 'leave') {
                d3.select('#w_row_' + code).style('background-color', 'white');
                d3.select('#w_button_' + code).style('color', color.purple);
            }       
        } 
        else {
            if (mode === 'enter') {
                d3.select('#w_button_' + code).style('color', color.pink);
            }
            else if (mode === 'leave') {
                d3.select('#w_button_' + code).style('color', color.purple);
            }
        }
    }

    function getColor() {
        if (selected) {
            return color.lightpurple;
        } else {
            return 'white';
        }
    }

    function setButton() {
        if (selected) {
            return '-';
        } else {
            return '+';
        }
    }

    function hoverCollapsed(mode) {
        if (mode === 'enter') {
            d3.select('#w_row_' + code).style('cursor', 'pointer');
            setPadding('5px 8px 10px 8px')
        } else if (mode === 'leave') {
            d3.select('#w_row_' + code).style('cursor', 'auto');
            setPadding('5px 8px 5px 8px')
        }
    }

    function clickRect(collapsed) {
        if (collapsed) {
            setCollapsed(false)
        }
        else {
            setCollapsed(true)
        }
    }

    function highlightWidgetQuery(string, search) {
        if (search === undefined || search === '') return string
        else {
            const parts = string.split(new RegExp(`(${search})`, 'gi'));
            return <span>{parts.map((part, i) => part.toLowerCase() === search.toLowerCase() ? <span key = {i} className = {'matchingQuery'}>{part}</span> : part)}</span>
        }
    }

    var dep1 = JSON.stringify(selected);

    useEffect(()=> {
        setCollapsed(selected);
    },[dep1])

    return (
        <div className = "w_row" id = {'w_row_' + code} onClick = {() => selected ? clickRect(collapsed) : null} onMouseOver = {() => selected ? hoverCollapsed('enter') : null} onMouseOut = {() => selected ? hoverCollapsed('leave') : null} style = {{'background': getColor(), 'border': selected ? '0.5px solid transparent' : '0.5px solid var(--purple)', 'padding': selected && padding}}>
            <div className = "w_row_first">
                <p className = "n_status" style = {{'color': added ? 'white' : color.pink}}>{!collapsed && format.longname(status)}</p>
                <p className = "n_longname" style = {{'color': added ? 'white' : color.purple}}>{collapsed ? format.longname(longname).substring(0, 18) + (longname.length > 18 ? ' ...' : '') : highlightWidgetQuery(format.longname(longname), search)}</p>
                <p className = "n_code" style = {{'color': added ? 'white' : color.purple}}>{!collapsed && highlightWidgetQuery(format.name(code), search)}</p>
            </div>
            <div className = "w_row_second">
                <p className = "w_button" id = {'w_button_' + code} style = {{'color': added ? 'white' : color.purple}} onMouseOver = {() => highlightNode('enter', selected)} onMouseOut = {() => highlightNode('leave', selected)} onClick = {() => selectNode(selected, code, cases)}>{setButton()}</p>
                <div>
                    <p className = "n_row_info" style = {{'color': added ? 'white' : color.gray}}>{!collapsed && 'Proximity:'}</p>
                    <p className = "n_row_info" style = {{'color': added ? 'white' : color.gray, 'fontWeight': 'bold'}}>{!collapsed && d3.format(".3f")(distance)}</p>    
                </div>
            </div>
        </div>
    );
}

export default Rect